<template>
    <div id="history-affilates-components">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12  col-xl-2 mb-3 mb-sm-0">
                       <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" aria-controls="my-table" v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12  col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs" v-model="filter" type="search" placeholder="Buscar por palabra">
                    </div>
                    <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                    <div class="col-12 "></div>
                </div>
            </div>
            <div class="row">
                <b-table sticky-header="80vh" responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination.data" :filter="filter">
                    <!-- A virtual column -->
                    <template #cell(cliente)="{item}">
                        {{ item.nombre }} {{ item.paterno }} {{ item.materno }}
                    </template>
                    <template #cell(fecha_nacimiento)="{item}">
                        {{ item.fechaNac }}
                    </template>
                    <template #cell(cliente_sku)="{item}">
                        {{ item.client_sku }}
                    </template>
                    <template #cell(titular_sku)="{item}">
                        {{ item.sku }}
                    </template>
                    <template #cell(acciones)="{item}">
                        <div class="dropdown">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-cogs"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Baja</a>
                            </div>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </main>
    </div>
</template>

<script>
import sweetAlert from 'sweetalert2'
import {myMixins} from "../mixins/myMixins";
import {affiliateTitularsService} from "../../Services/AffiliateTitularsService";


export default {
    name: "history-affiliate-titulars",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        },
        client_sku: {
            type: String,
            default: 0,
            require: false
        },

    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            person: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'cliente'},
                {key: 'fecha_nacimiento'},
                {key: 'cliente_sku'},
                {key: 'titular_sku'},
                {key: 'Acciones'}
            ],
            params: {
                sku: this.client_sku,
                limit: 10,
                page: 1,
                where: [],
            },
        }
    },
    methods: {
        async onClickDelete(id) {

            sweetAlert.fire({
                title: 'Esta seguro de esta operación?',
                text: "No podrás revertir esto.!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, borrarlo!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let resp = await affiliateTitularsService.deleteOne(id);
                    this.getAlert(resp.process);
                    await this.index();
                }
            })



        },
        async index() {
            this.isBusy = true;
            //console.log('client_sku', this.client_sku);
            this.pagination = await affiliateTitularsService.getMany(this.params);
            this.isBusy = false;
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
    },
    mounted() {
        this.index();
    }
}
</script>
